/**
 * File Name          : version.service.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { APP_VERSION } from '../../environments/version';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  constructor() { }

  async getVersion(): Promise<string> {
    if (Capacitor.isNativePlatform()) {
      const info = await App.getInfo();
      return `${info.version} (build ${info.build})`;
    }
    return APP_VERSION;
  }
}
